"use client";
import IMAGES from "./assetData";


export const HeroBannerSmImage = [
  {
    id: 1,
    img: IMAGES.elementImg1,
  },
  {
    id: 2,
    img: IMAGES.elementImg2,
  },
  {
    id: 3,
    img: IMAGES.elementImg3,
  },
  {
    id: 4,
    img: IMAGES.elementImg4,
  },
  {
    id: 5,
    img: IMAGES.elementImg5,
  },
  {
    id: 6,
    img: IMAGES.elementImg6,
  },
];


export const longTermDuration = [
  { id: 1, title: "7 Days", value: "7 day" },
  { id: 2, title: "14 Days", value: "14 day" },
  { id: 3, title: "21 Days", value: "21 day" },
  { id: 4, title: "1 Months", value: "30 day" },
  { id: 5, title: "3 Months", value: "90 day" },
  { id: 6, title: "6 Months", value: "180 day" },
];
